import { PageContainer } from "@/components/organisms";
import { Accordion } from "@/components/molecules/Accordion";
import {
  GeneralDetails,
  DeliveryAndStatusInfo,
  SubItemAccordionContent,
  TransactionDetailsAccordionContent,
  DiscountInformationAccordionContent,
} from "@/containers";

const OrderItemTab = ({ orderItemTabData , itemDetails}) => {
  const {
    subItemColConfigData,
  } = orderItemTabData || {};

  const subItems = itemDetails?.subItems || [];

  return (
    <>
      <PageContainer>
        <GeneralDetails generalDetails={itemDetails} />
        <DeliveryAndStatusInfo deliveryAndStausInfo={itemDetails} />
      </PageContainer>

      <div className="subItemAccordion mt-5">
        <Accordion
          isDark={true}
          content={
            <SubItemAccordionContent
              subItemAccordionData={{subItemList: subItems, subItemColConfigData}}
              itemDetails={itemDetails}
            />
          }
        />
      </div>
      <div className="transactionDetailsAccordion mt-5">
        <Accordion
          isDark={true}
          content={<TransactionDetailsAccordionContent transactionDetailsData={itemDetails} />}
        />
      </div>
      <div className="discountInfoAccordion mt-5">
        <Accordion
          isDark={true}
          content={<DiscountInformationAccordionContent discountInfoList={itemDetails?.discounts} />}
        />
      </div>
    </>
  )
};
export default OrderItemTab;
